// GuidedOfferSetup.js

import React, { useEffect, useState, useRef } from 'react';
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  StyleSheet,
  Modal,
  ScrollView,
  Alert,
  ActivityIndicator,
  Animated
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import * as DocumentPicker from 'expo-document-picker';

const steps = ['Intro', 'Venue Type', 'Basic Info', 'Description', 'Content Brief', 'Offer Details', 'Confirm'];



export default function GuidedOfferSetup({ navigation }) {
  const [step, setStep] = useState(0);
  const [sessionData, setSessionData] = useState(null);
  const [venueType, setVenueType] = useState('Restaurant');
  const [location, setLocation] = useState('');
  const [brandURL, setBrandURL] = useState('');

  const [city, setCity] = useState('');
  const [neighbourhood, setNeighbourhood] = useState('');
  const [isCityModalVisible, setIsCityModalVisible] = useState(false);
  const [isNeighbourhoodModalVisible, setIsNeighbourhoodModalVisible] = useState(false);
  const [citySearch, setCitySearch] = useState('');
  const [neighbourhoodSearch, setNeighbourhoodSearch] = useState('');

  const [listingDescription, setListingDescription] = useState('');
  const [nonCreditOffer, setNonCreditOffer] = useState('');
  const [credits, setCredits] = useState('');
  const [contentBrief, setContentBrief] = useState('Include our food and drink in your post and keep it organic!');
  const [preferredAvailability, setPreferredAvailability] = useState(new Date());
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [hasPrefilledInputs, setHasPrefilledInputs] = useState(false);
  const hasUserTyped = useRef(false);
  const [loading, setLoading] = useState(true);
  const progress = useRef(new Animated.Value(0)).current;

  const [availability, setAvailability] = useState([
    { day: 'Monday', open: '', close: '' },
    { day: 'Tuesday', open: '', close: '' },
    { day: 'Wednesday', open: '', close: '' },
    { day: 'Thursday', open: '', close: '' },
    { day: 'Friday', open: '', close: '' },
    { day: 'Saturday', open: '', close: '' },
    { day: 'Sunday', open: '', close: '' }
  ]);
  const [isTimeModalVisible, setIsTimeModalVisible] = useState(false);
  const [selectedDay, setSelectedDay] = useState('');
  const [selectedTimeType, setSelectedTimeType] = useState('');

  const timeOptions = [
    '10:00 AM', '11:00 AM', '12:00 PM', '1:00 PM',
    '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM',
    '6:00 PM', '7:00 PM', '8:00 PM', '9:00 PM', '10:00 PM'
  ];
  


  const cityOptions = ['London', 'Manchester'];

  const neighbourhoodOptions = {
    London: [
      'Angel',
      'Aldgate',
      'Baker Street',
      'Balham',
      'Bankside',
      'Battersea',
      'Bayswater',
      'Bermondsey',
      'Bethnal Green',
      'Bloomsbury',
      'Borough',
      'Brixton',
      'Camberwell',
      'Camden',
      'Canary Wharf',
      'Chelsea',
      'Chiswick',
      'Clapham',
      'Covent Garden',
      'Dalston',
      'Deptford',
      'Ealing',
      "Earl's Court",
      'Elephant and Castle',
      'Farringdon',
      'Finsbury Park',
      'Fulham',
      'Greenwich',
      'Hackney Central',
      'Hammersmith',
      'Hampstead',
      'Holborn',
      'Hoxton',
      'Islington',
      'Kensington',
      'Kentish Town',
      "King's Cross",
      'Knightsbridge',
      'Ladbroke Grove',
      'Lambeth',
      'Lewisham',
      'London Bridge',
      'Maida Vale',
      'Marylebone',
      'Mayfair',
      'Notting Hill',
      'Paddington',
      'Peckham',
      'Pimlico',
      'Richmond',
      'Shad Thames',
      "Shepherd's Bush",
      'Shoreditch',
      'Soho',
      'South Bank',
      'South Kensington',
      "St John's Wood",
      'Stratford',
      'Tooting',
      'Victoria',
      'Wandsworth',
      'West Hampstead',
      'Westminster',
      'Whitechapel',
      'Wimbledon',
      'Woolwich'
    ],
    Manchester: [
      'Ancoats',
      'Ardwick',
      'Baguley',
      'Blackley',
      'Burnage',
      'Castlefield',
      'Cheetham Hill',
      'Chorlton',
      'Chorlton-on-Medlock',
      'City Centre',
      'Clayton',
      'Collyhurst',
      'Crumpsall',
      'Didsbury',
      'Fallowfield',
      'Gorton',
      'Green Quarter',
      'Harpurhey',
      'Hulme',
      'Levenshulme',
      'Longsight',
      'Miles Platting',
      'Moss Side',
      'Moston',
      'New Islington',
      'Newton Heath',
      'Northern Quarter',
      'Old Moat',
      'Openshaw',
      'Rusholme',
      'Spinningfields',
      'Whalley Range',
      'Withington',
      'Wythenshawe'
    ]
  };

  const filteredCities = cityOptions.filter(item =>
    item.toLowerCase().includes(citySearch.toLowerCase())
  );

  const filteredNeighbourhoods = (neighbourhoodOptions[city] || []).filter(item =>
    item.toLowerCase().includes(neighbourhoodSearch.toLowerCase())
  );



  const [activityMetrics, setActivityMetrics] = useState(null);

  const [visibleTooltip, setVisibleTooltip] = useState('');
  const [showInfoModal, setShowInfoModal] = useState(false);

  const [countedBookings, setCountedBookings] = useState(0);
  const [countedUsers, setCountedUsers] = useState(0);
  const [countedReach, setCountedReach] = useState(0);
  



  const [showOfferGuide, setShowOfferGuide] = useState(true);
  const [submitting, setSubmitting] = useState(false);



const [validationErrors, setValidationErrors] = useState({});


  const [listingID, setListingID] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [uploadingImage, setUploadingImage] = useState(false);
  

const [isAuthenticated, setIsAuthenticated] = useState(true);
const [errorMessage, setErrorMessage] = useState('');


  const renderDynamicTooltip = (key, content) => (
    visibleTooltip === key && (
      <View style={{ backgroundColor: '#fff7cc', padding: 10, borderRadius: 8, marginTop: 5 }}>
        <Text style={{ fontSize: 12 }}>{content}</Text>
      </View>
    )
  );
  
  const openTimeModal = (day, type) => {
    setSelectedDay(day);
    setSelectedTimeType(type);
    setIsTimeModalVisible(true);
  };
  
  const handleTimeSelection = (day, type, value) => {
    const updated = availability.map(item =>
      item.day === day ? { ...item, [type]: value } : item
    );
    setAvailability(updated);
    setIsTimeModalVisible(false);
  };

  useEffect(() => {
    fetch('https://collabbayadmin.com/APIControllers/GetRecentActivity.php')
      .then(res => res.json())
      .then(data => {
        setActivityMetrics(data);
  
        // Count-up animation
        let i = 0;
        const totalSteps = 20;
        const interval = setInterval(() => {
          i++;
          setCountedBookings(Math.round((data.totalBookings / totalSteps) * i));
          setCountedUsers(Math.round((data.activeUsers / totalSteps) * i));
          setCountedReach(Math.round((data.combinedReach / totalSteps) * i));
          if (i === totalSteps) clearInterval(interval);
        }, 30);
      })
      .catch(console.error);
  }, []);
  

  const checkUserAuthentication = async () => {
  try {
    const response = await fetch('https://collabbayadmin.com/APIControllers/UserSubscriptionAuth.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include', // send session cookie
    });

    const data = await response.json();
    setIsAuthenticated(data.authenticated === true);

    if (!data.authenticated) {
      setErrorMessage('Subscribe to access collabbay features');
    } else {
      setErrorMessage('');
    }
  } catch (error) {
    console.error('Error checking authentication:', error);
    setErrorMessage('An error occurred while checking authentication.');
    setIsAuthenticated(false); // fail-safe: treat as not authed
  }
};

  
useEffect(() => {
  checkUserAuthentication();
}, []);


  useEffect(() => {
    const fetchAndPrefill = async () => {
      try {
const res = await fetch('https://collabbayadmin.com/APIControllers/GetSessionData.php', {
  credentials: 'include'
});
        const data = await res.json();
        setSessionData(data);

        const prefillLocation = data?.BusinessAddress || '';
        const prefillURL = data?.Username ? `${data.Username.replace(/\s+/g, '').toLowerCase()}.com` : '';
        const description = `${data?.Username} is a ${venueType.toLowerCase()} located at ${prefillLocation}.`;

        if (!hasUserTyped.current) {
          setLocation(prefillLocation);
          setBrandURL(prefillURL);
          setListingDescription(description);
        }

        setHasPrefilledInputs(true);
        setLoading(false);
      } catch (err) {
        console.error('Session fetch failed:', err);
      }
    };

    if (!hasPrefilledInputs) {
      fetchAndPrefill();
    }
  }, [venueType]);

  useEffect(() => {
    Animated.timing(progress, {
      toValue: (step + 1) / steps.length,
      duration: 300,
      useNativeDriver: false
    }).start();
  }, [step]);


  
  const handlePickImage = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
  
    input.onchange = () => {
      const file = input.files[0];
      if (file) {
        setImageFile({
          uri: URL.createObjectURL(file),
          name: file.name,
          type: file.type,
          fileObject: file
        });
      }
    };
  
    input.click();
  };
  
  

const validateOfferDetailsStep = () => {
  const errors = {};
  if (!nonCreditOffer.trim()) errors.nonCreditOffer = true;
  if (!credits.trim()) errors.credits = true;

  const hasAvailability = availability.some(day => day.open && day.close);
  if (!hasAvailability) errors.availability = true;

  setValidationErrors(errors);
  return Object.keys(errors).length === 0;
};


  const handleSubmit = async () => {
    if (submitting) return; // prevent multiple clicks
  
if (
  !nonCreditOffer.trim() ||
  !credits.trim() ||
  !listingDescription.trim() ||
  !location.trim() ||
  !city.trim() ||
  !neighbourhood.trim()
) {
  Alert.alert('Missing Info', 'Please complete all required fields, including full address, city and neighbourhood.');
  return;
}
  
    setSubmitting(true); // start loading
  

    const body = {
      Location: location,
      City: city,
      Neighbourhood: neighbourhood,
      ListingDescription: listingDescription,
      AdHeader: `Come and visit ${sessionData?.Username}`,
      BrandURL: brandURL,
      Credits: credits,
      PreferredAvailability: availability
        .filter(day => day.open && day.close)
        .map(day => `${day.day}: ${day.open} - ${day.close}`)
        .join(', '),
      ContentBrief: contentBrief,
      NonCreditOffer: nonCreditOffer,
      MinFollowersRequired: 'No min.',
      TurnAroundDays: 4,
      AdditionalBookingDetails: 'N',
      OfferCategory: venueType
    };
  
    try {
      const res = await fetch('https://collabbayadmin.com/APIControllers/GuidedOfferPost.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
  
      const result = await res.json();
   
   if (result?.message === 'Data inserted successfully' && result?.ListingID) {
  setListingID(result.ListingID); // Capture inserted ID
  setShowSuccessModal(true);
}

   else {
        Alert.alert('Error', result?.error || 'Failed to post offer.');
      }
    } catch (error) {
      Alert.alert('Network Error', 'Please try again later.');
    } finally {
      setSubmitting(false); // done loading
    }
  };
  

  const renderTip = (message) => (
    <View style={styles.tipBox}>
      <Ionicons name="information-circle" size={16} color="#555" />
      <Text style={styles.tipText}>{message}</Text>
    </View>
  );

  const renderStep = () => {
    if (loading) return <ActivityIndicator size="large" color="#000" style={{ marginTop: 50 }} />;

    switch (step) {

      case 0:
        return (
          <View style={{ backgroundColor: '#f3f3f3', borderRadius: 16, padding: 20, marginTop: 10 }}>
            <Text style={{ fontSize: 16, fontWeight: 'bold', marginBottom: 5 }}>You're about to post to the marketplace.</Text>
            <Text style={{ fontSize: 14, marginBottom: 15, color: '#333' }}>
              You’re about to list your venue to the influencer marketplace.
              Hundreds of creators are active on the platform, and they'll see your offer— so you need to ensure your listing shows off your brand in the best way possible to attract bookings and interest.
            </Text>
      
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: 10 }}>
              <View style={{ flex: 1, marginRight: 8, backgroundColor: '#fff', borderRadius: 10, padding: 12 }}>
                <Text style={{ fontSize: 22, fontWeight: 'bold', color: '#222' }}>{countedBookings}</Text>
                <Text style={{ fontSize: 12, color: '#666' }}>Total Bookings Sent</Text>
              </View>
              <View style={{ flex: 1, marginLeft: 8, backgroundColor: '#fff', borderRadius: 10, padding: 12 }}>
                <Text style={{ fontSize: 22, fontWeight: 'bold', color: '#222' }}>{countedUsers}</Text>
                <Text style={{ fontSize: 12, color: '#666' }}>Active Creators This Week</Text>
              </View>
            </View>
            <View style={{ backgroundColor: '#fff', borderRadius: 10, padding: 12 }}>
  <Text style={{ fontSize: 22, fontWeight: 'bold', color: '#222' }}>{countedReach.toLocaleString()}</Text>
  <Text style={{ fontSize: 12, color: '#666' }}>Live Combined Follower Count</Text>
</View>

<TouchableOpacity onPress={() => window.open('https://collabbayadmin.com/Guide', '_blank')} style={{ flexDirection: 'row', alignItems: 'center', marginTop: 15 }}>
  <Ionicons name="arrow-forward" size={16} color="black" style={{ marginRight: 6 }} />
  <Text style={{ fontSize: 14, fontWeight: 'bold', textDecorationLine: 'underline', color: 'black' }}>
    Before you start, check out these tips
  </Text>
</TouchableOpacity>

          </View>
        );
      
    
      case 1:
        return (
          <View>
            <Text style={styles.label}>What type of venue are you?</Text>
            {['Restaurant', 'Bar', 'Activity', 'Takeout Spot', 'Wellbeing and Fitness', 'Gym'].map(option => (
              <TouchableOpacity
                key={option}
                style={[styles.optionButton, venueType === option && styles.selected]}
                onPress={() => setVenueType(option)}>
                <Text>{option}</Text>
              </TouchableOpacity>
            ))}
            {renderTip('This helps us tailor your offer listing to the right audience.')}
          </View>
        );

  

         case 2:
        return (
          <View>
            <Text style={styles.label}>Full Location <Text style={styles.badge}>Auto-Suggested</Text></Text>
            {renderTip('Keep the full address here, including your postcode.')}

            <TextInput
              value={location}
              placeholder="E.g. 123 Main St, London"
              maxLength={150}
              onChangeText={(t) => {
                if (!hasUserTyped.current) hasUserTyped.current = true;
                setLocation(t);
                setValidationErrors(prev => ({
                  ...prev,
                  location: t.trim() === ''
                }));
              }}
              style={[
                styles.input,
                location.trim() === '' && { backgroundColor: '#ffe5e5' }
              ]}
            />
            <Text style={{ fontSize: 12, textAlign: 'right', color: '#888' }}>{location.length}/150</Text>

            <Text style={styles.label}>City</Text>
            <TouchableOpacity
              style={styles.selectorButton}
              onPress={() => {
                setCitySearch('');
                setIsCityModalVisible(true);
              }}
            >
              <Text style={city ? styles.selectorValue : styles.selectorPlaceholder}>
                {city || 'Select city'}
              </Text>
              <Ionicons name="chevron-down" size={18} color="#333" />
            </TouchableOpacity>

            <Text style={styles.label}>Neighbourhood</Text>
            <TouchableOpacity
              style={[
                styles.selectorButton,
                !city && { opacity: 0.5 }
              ]}
              onPress={() => {
                if (!city) {
                  Alert.alert('Select City First', 'Please choose a city before selecting a neighbourhood.');
                  return;
                }
                setNeighbourhoodSearch('');
                setIsNeighbourhoodModalVisible(true);
              }}
            >
              <Text style={neighbourhood ? styles.selectorValue : styles.selectorPlaceholder}>
                {neighbourhood || 'Select neighbourhood'}
              </Text>
              <Ionicons name="chevron-down" size={18} color="#333" />
            </TouchableOpacity>

            {renderTip('Choose the city and general neighbourhood so we can structure your venue location cleanly.')}

            <Text style={styles.label}>Your Website <Text style={styles.badge}>Auto-Suggested</Text></Text>
            <TextInput
              value={brandURL}
              maxLength={150}
              onChangeText={(t) => {
                if (!hasUserTyped.current) hasUserTyped.current = true;
                setBrandURL(t);
              }}
              style={styles.input}
            />

            {renderTip('You can update these details if they’re incorrect.')}

            <Modal
              visible={isCityModalVisible}
              transparent={true}
              animationType="slide"
              onRequestClose={() => setIsCityModalVisible(false)}
            >
              <View style={styles.modalOverlay}>
                <View style={styles.selectionModalCard}>
                  <Text style={styles.selectionModalTitle}>Select City</Text>

                  <TextInput
                    value={citySearch}
                    onChangeText={setCitySearch}
                    placeholder="Search city..."
                    style={styles.selectionSearchInput}
                  />

                  <ScrollView style={styles.selectionScroll}>
                    {filteredCities.map((item) => (
                      <TouchableOpacity
                        key={item}
                        style={styles.selectionOption}
                      onPress={() => {
  setCity(item);
  setNeighbourhood('');
  setNeighbourhoodSearch('');
  setIsCityModalVisible(false);
}}
                      >
                        <Text style={styles.selectionOptionText}>{item}</Text>
                      </TouchableOpacity>
                    ))}
                  </ScrollView>

                  <TouchableOpacity
                    onPress={() => setIsCityModalVisible(false)}
                    style={styles.selectionCancelBtn}
                  >
                    <Text style={styles.selectionCancelText}>Cancel</Text>
                  </TouchableOpacity>
                </View>
              </View>
            </Modal>

            <Modal
              visible={isNeighbourhoodModalVisible}
              transparent={true}
              animationType="slide"
              onRequestClose={() => setIsNeighbourhoodModalVisible(false)}
            >
              <View style={styles.modalOverlay}>
                <View style={styles.selectionModalCard}>
                  <Text style={styles.selectionModalTitle}>Select Neighbourhood</Text>

                  <TextInput
                    value={neighbourhoodSearch}
                    onChangeText={setNeighbourhoodSearch}
                    placeholder="Search neighbourhood..."
                    style={styles.selectionSearchInput}
                  />

                  <ScrollView style={styles.selectionScroll}>
                    {filteredNeighbourhoods.map((item) => (
                      <TouchableOpacity
                        key={item}
                        style={styles.selectionOption}
                        onPress={() => {
                          setNeighbourhood(item);
                          setIsNeighbourhoodModalVisible(false);
                        }}
                      >
                        <Text style={styles.selectionOptionText}>{item}</Text>
                      </TouchableOpacity>
                    ))}
                  </ScrollView>

                  <TouchableOpacity
                    onPress={() => setIsNeighbourhoodModalVisible(false)}
                    style={styles.selectionCancelBtn}
                  >
                    <Text style={styles.selectionCancelText}>Cancel</Text>
                  </TouchableOpacity>
                </View>
              </View>
            </Modal>
          </View>
        );

      case 3:
        return (
          <View>
            <Text style={styles.label}>Suggested Description <Text style={styles.badge}>Auto-Suggested</Text></Text>
            <TextInput
              style={[styles.input, { height: 100 }]}
              value={listingDescription}
              onChangeText={text => setListingDescription(text)}
              maxLength={525}
              multiline
            />
            <Text style={{ fontSize: 12, color: '#666', textAlign: 'right', marginBottom: 10 }}>{listingDescription.length}/525</Text>
            {renderTip("We've started this for you. It's auto-generated based on your venue type but editable.")}
          </View>
        );
      case 4:
        return (
          <View>
            <TouchableOpacity onPress={() => setVisibleTooltip('desc')}>
  <Ionicons name="information-circle" size={16} color="grey" />
</TouchableOpacity>
{renderDynamicTooltip('desc', 'Describe the vibe — make the venue sound exciting and unique.')}

            <Text style={styles.label}>Content Brief <Text style={styles.badge}>Suggested</Text></Text>
            <TextInput
              value={contentBrief}
              maxLength={100}
              onChangeText={text => setContentBrief(text)}
              style={styles.input}
            />
            <Text style={{ fontSize: 12, color: '#666', textAlign: 'right', marginBottom: 10 }}>{contentBrief.length}/100</Text>
            {renderTip('Let creators know what to include in their content.')}
          </View>

          
        );
      case 5:
        return (
          <View>
            <Text style={styles.label}>What are you offering to creators?</Text>
        <TextInput
  value={nonCreditOffer}
  placeholder="E.g. 2 Mains, 2 Sides, 2 Drinks (comped)"
  onChangeText={(t) => {
    setNonCreditOffer(t);
    setValidationErrors(prev => ({
      ...prev,
      nonCreditOffer: t.trim() === ''
    }));
  }}
  style={[
    styles.input,
    nonCreditOffer.trim() === '' && { backgroundColor: '#ffe5e5' }
  ]}
/>


            <Text style={styles.label}>Value of Offer (£)</Text>
  <TextInput
  value={credits}
  placeholder="E.g. £70 (menu-value)"
  keyboardType="numeric"
  onChangeText={(t) => {
    const val = t.replace(/[^0-9]/g, '');
    if (parseInt(val) <= 500) setCredits(val);
    setValidationErrors(prev => ({
      ...prev,
      credits: val.trim() === ''
    }));
  }}
  style={[
    styles.input,
    credits.trim() === '' && { backgroundColor: '#ffe5e5' }
  ]}
/>


          <Text style={styles.label}>Set Your Availability <Text style={styles.badge}>Required</Text></Text>
<Text style={{ fontSize: 12, color: '#666', marginBottom: 10 }}>
  Select open and close times for each day. Note: The mnore hours your venue is available, the more booking requests you can accept. Leave blank for closed days.
</Text>

<View style={[
  {
    backgroundColor: '#f5f5f5',
    borderRadius: 10,
    padding: 10,
    marginBottom: 20
  },
  validationErrors.availability && { backgroundColor: '#ffe5e5' }
]}>

  {availability.map((item, index) => (
    <View key={index} style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 3 }}>
      <Text style={{ flex: 1 }}>{item.day}</Text>
      <TouchableOpacity
        style={[styles.input, { flex: 1, marginRight: 5 }]}
        onPress={() => openTimeModal(item.day, 'open')}>
        <Text>{item.open || '-'}</Text>
      </TouchableOpacity>
      <TouchableOpacity
        style={[styles.input, { flex: 1 }]}
        onPress={() => openTimeModal(item.day, 'close')}>
        <Text>{item.close || '-'}</Text>
      </TouchableOpacity>
    </View>
  ))}
</View>
{renderTip('Set the preferred visit time window for creators.')}



<Modal
  visible={isTimeModalVisible}
  transparent={true}
  animationType="slide"
  onRequestClose={() => setIsTimeModalVisible(false)}
>
  <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000099' }}>
    <View style={{ backgroundColor: 'white', borderRadius: 16, padding: 20, width: '80%' }}>
      <Text style={{ fontWeight: 'bold', fontSize: 16, marginBottom: 10 }}>Select Time</Text>
      <ScrollView contentContainerStyle={{ paddingBottom: 20 }}>
        {timeOptions.map((time, index) => (
          <TouchableOpacity
            key={index}
            onPress={() => handleTimeSelection(selectedDay, selectedTimeType, time)}
            style={{ paddingVertical: 10, borderBottomWidth: 1, borderBottomColor: '#eee' }}
          >
            <Text>{time}</Text>
          </TouchableOpacity>
        ))}
      </ScrollView>
      <TouchableOpacity onPress={() => setIsTimeModalVisible(false)} style={{ marginTop: 10 }}>
        <Text style={{ color: 'black', textAlign: 'center' }}>Cancel</Text>
      </TouchableOpacity>
    </View>
  </View>
</Modal>

          </View>
        );
      case 6:
        return (
          <View style={[styles.card, { backgroundColor: '#f9f9f9', padding: 20, borderRadius: 16 }]}>            
{!isAuthenticated && (
  <TouchableOpacity
    style={styles.setupLaterBtn}
    onPress={() => navigation.navigate('WelcomeOptions')}
  >
    <Text style={styles.setupLaterText}>Set up later</Text>
  </TouchableOpacity>
)}


          {renderTip('Influencers will only be able to book within the hours you set.')}

            <Text style={[styles.label, { marginBottom: 15 }]}>Happy with this?</Text>
            <Text style={styles.confirmText}>🎯 <Text style={styles.confirmLabel}>Venue Type:</Text> {venueType}</Text>
            <Text style={styles.confirmText}>📍 <Text style={styles.confirmLabel}>Location:</Text> {location}</Text>
            <Text style={styles.confirmText}>🏙️ <Text style={styles.confirmLabel}>City:</Text> {city || 'Not selected'}</Text>
            <Text style={styles.confirmText}>📌 <Text style={styles.confirmLabel}>Neighbourhood:</Text> {neighbourhood || 'Not selected'}</Text>
            <Text style={styles.confirmText}>🌐 <Text style={styles.confirmLabel}>Website:</Text> {brandURL}</Text>
            <Text style={styles.confirmText}>📝 <Text style={styles.confirmLabel}>Content Brief:</Text> {contentBrief}</Text>
            <Text style={styles.confirmText}>🎁 <Text style={styles.confirmLabel}>Offer:</Text> {nonCreditOffer}</Text>
            <Text style={styles.confirmText}>💰 <Text style={styles.confirmLabel}>Value (£):</Text> {credits}</Text>

            {renderTip('All set? If not, go back to adjust. When you’re ready, hit submit.')}
            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
  
</View>
{showInfoModal && (
  <Modal transparent animationType="fade" visible={showInfoModal}>
    <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(0,0,0,0.6)' }}>
      <View style={{ backgroundColor: 'white', padding: 20, borderRadius: 16, width: '85%' }}>
        <Text style={{ fontWeight: 'bold', marginBottom: 10 }}>What is the offer value?</Text>
        <Text style={{ fontSize: 14, marginBottom: 20 }}>
          This is the estimated value of the goods/services included in the offer.{"\n\n"}
          Example: 2 comped mains worth £25 each = a £50 offer value.{"\n\n"}
          Note: This is not a cash payout, but a comped experience.{"\n\n"}
          Ensure the value reflects what the influencer will receive.
        </Text>
        <TouchableOpacity style={styles.submitBtn} onPress={() => setShowInfoModal(false)}>
          <Text style={{ textAlign: 'center' }}>Makes sense 👍</Text>
        </TouchableOpacity>
      </View>
    </View>
  </Modal>
)}

          </View>
        );
      default:
        return null;
    }
  };

  return (
    <View style={styles.wrapper}>
      <View style={styles.progressBarBackground}>
        <Animated.View style={[styles.progressBarFill, { width: progress.interpolate({ inputRange: [0, 1], outputRange: ['0%', '100%'] }) }]} />
      </View>
      <TouchableOpacity onPress={() => navigation.goBack()} style={styles.exitButton}>
        <Ionicons name="arrow-back" size={20} color="black" />
        <Text style={{ fontWeight: '600', marginLeft: 6 }}>Exit</Text>
      </TouchableOpacity>
      <View style={styles.card}>
        <ScrollView contentContainerStyle={styles.container}>
          <Text style={styles.stepTitle}>
  {step === 0 ? 'Post Your Offer' : steps[step]}
</Text>
          {renderStep()}



          <View style={styles.navigationButtons}>
            {step > 0 && <TouchableOpacity style={styles.navBtn} onPress={() => setStep(step - 1)}><Text>Back</Text></TouchableOpacity>}
            {step < steps.length - 1 ? (
            <TouchableOpacity
  style={styles.navBtnFwd}
  onPress={() => {
    if (step === 5) {
      if (validateOfferDetailsStep()) {
        setStep(step + 1);
      } else {
        Alert.alert('Missing Info', 'Please complete all required fields before continuing.');
      }
    } else {
      setStep(step + 1);
    }
  }}
>
  <Text>Next</Text>
</TouchableOpacity>

            ) : (
              <TouchableOpacity
              style={[styles.submitBtn, submitting && { opacity: 0.6 }]}
              onPress={handleSubmit}
              disabled={submitting}
            >
              {submitting ? (
                <ActivityIndicator color="black" />
              ) : (
                <Text style={{ fontWeight: 'bold' }}>Post Listing</Text>
              )}
            </TouchableOpacity>
            
            )}
          </View>
        </ScrollView>
      </View>
     {showSuccessModal && (
  <Modal transparent animationType="fade" visible={showSuccessModal}>
   <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(0,0,0,0.6)' }}>
  <View style={{ backgroundColor: 'white', padding: 25, borderRadius: 20, alignItems: 'center', width: '90%' }}>
    <Ionicons name="checkmark-circle" size={90} color="green" style={{ marginBottom: 15 }} />
    
    <Text style={{ fontSize: 18, fontWeight: 'bold', marginBottom: 8 }}>Offer Posted</Text>
    
    <Text style={{ fontSize: 14, textAlign: 'center', marginBottom: 8 }}>
      Upload a great primary photo to help your listing stand out.
    </Text>

    <View style={{ flexDirection: 'row', alignItems: 'center', backgroundColor: '#f3f3f3', padding: 8, borderRadius: 10, marginBottom: 20, width: '100%' }}>
      <Ionicons name="create-outline" size={16} color="#333" style={{ marginRight: 6 }} />
      <Text style={{ fontSize: 13, color: '#333', flex: 1 }}>
        Recommended: Once done, add more images to your gallery on the following page.
      </Text>
    </View>

    {/* File picker trigger */}
    <TouchableOpacity
      onPress={handlePickImage}
      style={{ backgroundColor: '#fdf05d', padding: 12, borderRadius: 10, width: '100%', marginBottom: 10 }}
    >
      <Text style={{ fontWeight: 'bold', textAlign: 'center' }}>
        {imageFile ? 'Change Banner Image' : 'Choose Banner Image'}
      </Text>
    </TouchableOpacity>

    {/* Upload button */}
    {imageFile && (
      <TouchableOpacity
        onPress={async () => {
          setShowSuccessModal(false);

          setTimeout(() => {
navigation.navigate('MyOffers', { forceRefresh: true });
          }, 100);

          if (!listingID || !imageFile) return;
          setUploadingImage(true);

          const formData = new FormData();
          formData.append('image', imageFile.fileObject);
          formData.append('ListingID', listingID);

          try {
            const res = await fetch('https://collabbayadmin.com/APIControllers/UploadListingImage.php', {
              method: 'POST',
              body: formData,
            });

            const text = await res.text();

            if (res.ok && text.includes("Logo Image Updated")) {
              console.log('Upload complete');
            } else {
              console.warn('Upload failed', text);
            }
          } catch (err) {
            console.error('Upload error', err.message);
          } finally {
            setUploadingImage(false);
          }
        }}
        style={{ backgroundColor: '#000', padding: 12, borderRadius: 10, width: '100%' }}
        disabled={uploadingImage}
      >
        <Text style={{ color: 'white', fontWeight: 'bold', textAlign: 'center' }}>
          {uploadingImage ? 'Uploading...' : 'Upload and Finish'}
        </Text>
      </TouchableOpacity>
    )}
  </View>
</View>

  </Modal>
)}

    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: { flex: 1, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#f0f0f0' },
  exitButton: { flexDirection: 'row', alignItems: 'center', alignSelf: 'flex-start', marginLeft: 20, marginTop: 10 },
  card: { backgroundColor: 'white', borderRadius: 20, width: '95%', borderWidth: 1, borderColor: '#ccc', marginTop: 10 },
  container: { padding: 20 },
  stepTitle: { fontSize: 20, fontWeight: 'bold', marginBottom: 10 },
  label: { marginBottom: 5, fontWeight: '600' },
  badge: { backgroundColor: '#FDF05D', paddingHorizontal: 6, paddingVertical: 2, fontSize: 12, borderRadius: 6 },
  input: { backgroundColor: '#f5f5f5', borderRadius: 10, padding: 10, marginBottom: 15, borderColor: '#ccc', borderWidth: 1 },
  optionButton: { padding: 10, backgroundColor: '#eee', marginVertical: 5, borderRadius: 8 },
  selected: { backgroundColor: '#FDF05D' },
  navigationButtons: { flexDirection: 'row', justifyContent: 'space-between', marginTop: 20 },
  navBtn: { padding: 12, borderRadius: 10, backgroundColor: '#ddd' },
  navBtnFwd: { padding: 12, borderRadius: 10, backgroundColor: '#fdf05d' },
  submitBtn: { padding: 12, borderRadius: 10, backgroundColor: '#FDF05D' },
  tipBox: { flexDirection: 'row', alignItems: 'center', marginTop: 5 },
  tipText: { marginLeft: 6, fontSize: 12, color: '#666' },
  confirmText: { marginBottom: 8, fontSize: 15 },
  confirmLabel: { fontWeight: 'bold' },
  progressBarBackground: { height: 6, width: '100%', backgroundColor: '#ddd' },
  progressBarFill: { height: 6, backgroundColor: '#FDF05D' },
    selectorButton: {
    backgroundColor: '#f5f5f5',
    borderRadius: 10,
    padding: 14,
    marginBottom: 15,
    borderColor: '#ccc',
    borderWidth: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  selectorPlaceholder: {
    color: '#888',
    fontSize: 14
  },
  selectorValue: {
    color: '#111',
    fontSize: 14,
    fontWeight: '500'
  },
  modalOverlay: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.55)'
  },
  selectionModalCard: {
    width: '88%',
    maxHeight: '75%',
    backgroundColor: '#fff',
    borderRadius: 18,
    padding: 18
  },
  selectionModalTitle: {
    fontSize: 17,
    fontWeight: '700',
    marginBottom: 12,
    color: '#111'
  },
  selectionSearchInput: {
    backgroundColor: '#f5f5f5',
    borderRadius: 10,
    padding: 12,
    borderColor: '#ddd',
    borderWidth: 1,
    marginBottom: 12
  },
  selectionScroll: {
    maxHeight: 350
  },
  selectionOption: {
    paddingVertical: 14,
    paddingHorizontal: 4,
    borderBottomWidth: 1,
    borderBottomColor: '#eee'
  },
  selectionOptionText: {
    fontSize: 15,
    color: '#111'
  },
  selectionCancelBtn: {
    marginTop: 14,
    backgroundColor: '#f3f3f3',
    borderRadius: 10,
    paddingVertical: 12
  },
  selectionCancelText: {
    textAlign: 'center',
    fontWeight: '600',
    color: '#111'
  }
});